import Banner from '@rio-cloud/rio-uikit/Banner';
import { FormattedMessage } from 'react-intl';
import { config } from '../../../../../config';

export const PocketDriverMaintenanceBanner = () => {
    return (
        <Banner show dismissible={false} initialAnimation={false} className='margin-bottom-20'>
            <Banner.Page>
                <Banner.Icon>
                    <span
                        aria-hidden='true'
                        className='rioglyph rioglyph-warning-sign text-color-warning text-size-20'
                    />
                </Banner.Icon>
                <Banner.Content>
                    <FormattedMessage
                        id='intl-msg:create-new-dialog.telematics.pocket-driver-maintenance'
                        values={{ maintenanceEnd: config.pocketDriverRegistrationMaintenanceEnd }}
                    />
                </Banner.Content>
            </Banner.Page>
        </Banner>
    );
};
